export default {
  CAccordion: 'Accordion',
  CAccordionFeatures: 'Accordion Features',
  CBeforeAfterImage: 'Before After Image',
  CBox: 'Box',
  CToggleTab: 'Toggle Tab',
  CBulletList: 'Bullet List',
  CLinkList: 'Link List',
  CSocialLinks: 'Social Links',
  CPillsList: 'Pills List',
  CTyper: 'Typer List',
  CButton: 'Button',
  CButtonGroup: 'Button Group',
  CAvatar: 'Avatar',
  COrderForm: 'Order Form',
  COrderFormNew: 'Order Form New',
  COrderConfirmation: 'Order Confirmation Form',
  CCountdown: 'Countdown',
  CDivider: 'Divider',
  CHtml: 'Html',
  CFactBox: 'Fact Box',
  CImage: 'Image',
  CImageBox: 'Image Box',
  CRating: 'Rating',
  CImageGrid: 'Image Grid',
  CEndorsementGroup: 'Endorsement Group',
  CImageAndText: 'Image And Text',
  CInlineCountdown: 'Inline Countdown',
  CInlineVideo: 'Inline Video',
  CLowStockIndicator: 'Low Stock Indicator',
  CMultiStepForm: 'Multistep Form',
  CInspiration: 'Inspiration',
  CQuoteTestimonial: 'Quote Testimonial',
  CProduct: 'Product',
  CRow: 'Row',
  CReviews: 'Reviews',
  CSection: 'Section',
  CStepDisplay: 'Step Display',
  CTabs: 'Tabs',
  CTestimonial: 'Testimonial',
  CTestimonialImage: 'Testimonial Image',
  CTestimonialLogo: 'Testimonial Logo',
  CTestimonialFeature: 'Testimonial Feature',
  CTestimonialGrid: 'Testimonial Grid',
  CText: 'Text',
  CTitle: 'Title',
  CUpsell: 'Upsell',
  CVideoEmbed: 'Video',
  CProgressBar: 'Progress Bar',
  CShowMoreBox: 'Show More Box',
};
